import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import WidgetGrid from '../../../components/layout/widgets/WidgetGrid'
import JarvisWidget from '../../../components/layout/widgets/JarvisWidget'
import style from './SingleProdReview.module.css'
import { connect } from 'react-redux'
import { deleteReviewList, getReviews } from '../../../common/actions/retailer'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import imageUrl from '../../../common/utils/imageUrl'
import defaultDiamondImage from '../../../assets/images/image-coming-soon.jpg'

const getApiErrorMessage = error => {
  if (!error) return 'An unexpected error occurred.'
  const status = error.response && error.response.status
  const data = error.response && error.response.data
  if (status === 401) return 'Your session has expired. Please log in again.'
  if (status === 422) {
    if (data && data.errors && typeof Object.values(data.errors)[0] === 'string') {
      return Object.values(data.errors).join(' ')
    }
    if (data && data.message) return data.message
    return 'Invalid request. Please try again.'
  }
  if (status === 500) return 'Server error. Please try again later.'
  if (status === 400) return 'Bad request. Please check your input and try again.'
  if (data && data.message) return data.message
  return error.message || 'An unexpected error occurred.'
}

function SingleProdReview({ review, Deletereview }) {
  const [allReview, setAllReview] = useState([])
  const [loading, setLoading] = useState(true)
  const [productInfo, setProductInfo] = useState(null)
  const navigate = useNavigate()

  const parseReviews = res =>
    (res.data || []).map(item => ({ id: item.data.id, ...item.data.attributes }))

    useEffect(() => {
      const urlParts = window.location.href.split('/')
      const idFromUrl = urlParts[urlParts.length - 1]

      review(idFromUrl)
        .then(res => {
          setAllReview(parseReviews(res))
          // The API returns { data: [...], product: {...} } but the jsonapi
          // wrapper wraps `res` in a Collection/Entity, stashing the raw
          // body on `_raw`. Read the product from either shape.
          setProductInfo(res?.product || res?._raw?.product || null)
        })
        .catch(() => {
          setAllReview([])
          setProductInfo(null)
        })
        .finally(() => setLoading(false))
    }, [])

  const handleDeleteReview = (reviewId, userId) => {
    toast(
      ({ closeToast }) => (
        <div>
          <p>Are you sure you want to delete this review?</p>
          <button
            style={{ marginRight: '10px' }}
            className='btn btn-primary mx-2'
            onClick={() => { deleteReview(reviewId, userId); closeToast(); }}
          >
            Yes
          </button>
          <button className='btn btn-danger mx-2' onClick={closeToast}>No</button>
        </div>
      ),
      { position: toast.POSITION.TOP_CENTER, autoClose: false, closeOnClick: false, draggable: false, draggablePercent: 0 }
    )
  }

  const deleteReview = (reviewId) => {
    const data = { review_id: reviewId }
    Deletereview(data)
      .then(() => {
        const urlParts = window.location.href.split('/')
        const idFromUrl = urlParts[urlParts.length - 1]
        toast.success('Review deleted successfully!')
        review(idFromUrl)
          .then(res => {
            setProductInfo(res?.product || res?._raw?.product || null)
            if (res.success !== false) {
              setAllReview(parseReviews(res))
            } else {
              setAllReview([])
            }
          })
          .catch(() => setAllReview([]))
      })
      .catch(error => {
        toast.error(getApiErrorMessage(error))
      })
  }

  const renderProductInfoBanner = () => {
    if (!productInfo) return null

    const {
      uuid: internal_id,
      first_image_path,
      price,
      setting,
      status,
      retailer_name,
      title,
      custom_title
    } = productInfo

    const productImage = first_image_path || defaultDiamondImage

    return (
      <div
        style={{
          padding: '15px 20px',
          borderBottom: '1px solid #e5e5e5',
          background: '#f9f9f9',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}
      >
        <img
          src={productImage}
          alt="Product"
          onError={e => {
            e.target.onerror = null
            e.target.src = defaultDiamondImage
          }}
          style={{
            width: 80,
            height: 80,
            objectFit: 'cover',
            borderRadius: 4,
            border: '1px solid #ddd'
          }}
        />

        <div style={{ flex: 1, minWidth: 200 }}>
          {/* <h4 style={{ marginTop: 0 }}>
            {custom_title || title || 'Untitled Product'}
          </h4> */}

          {internal_id && (
            <div>
              <strong>Product ID:</strong> {internal_id}
            </div>
          )}

          <div>
            <strong>Status:</strong> {status}
          </div>

          <div>
            <strong>Price:</strong> ${price}
          </div>

          <div>
            <strong>Setting:</strong> {setting}
          </div>

          <div>
            <strong>Retailer:</strong> {retailer_name}
          </div>
        </div>
      </div>
    )
  }

  const reviewArray = Array.isArray(allReview) ? allReview : []
  return (
    <div>
      <ToastContainer />
      <div id="content">
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget editbutton={false} togglebutton={false} fullscreenbutton={false} deletebutton={false} color="darken">
                <header>
                  <span className="widget-icon"><i className="fa fa-list" /></span>
                  <h2>Product reviews</h2>
                  <div className="widget-toolbar">
                    <button
                      className="btn btn-default btn-sm"
                      onClick={() => navigate('/productReview')}
                    >
                      <i className="fa fa-arrow-left" /> Back
                    </button>
                  </div>
                </header>
                <div className='produtereviewdetails'>
                  {renderProductInfoBanner()}
                  <div className="widget-body no-padding listdetails_view">
                    <div className='prod_add'>
                      <div className='prod_add_review_option'>
                        <ul className='allreviewlist'>
                          {loading ? (
                            <li style={{ textAlign: 'center', width: '100%', display: 'block', padding: '40px 0' }}>
                              <i className="fa fa-spinner fa-pulse fa-3x fa-fw" style={{ color: '#40cba4' }} />
                            </li>
                          ) : reviewArray.length > 0 ? (
                            reviewArray.map(rev => (
                              <li key={rev.id}>
                                <div className='reviewinfo'>
                                  <h4>{rev.userName}</h4>
                                  <p><small>Posted on: {new Date(rev.createdAt).toLocaleDateString()}</small> -- <span style={{ color: '#40cba4' }}>Ratings: {rev.ratingValue}/5</span></p>
                                  <p>{rev.message}</p>
                                </div>
                                <div className='trashopt2'>
                                  <span className='deleateicon'>
                                    <a onClick={() => handleDeleteReview(rev.id)} className='btn btn-danger'>
                                      <i className="fa fa-lg fa-trash"></i>
                                    </a>
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li style={{ textAlign: 'center', width: '100%', display: 'block', fontSize: '24px', color: '#40cba4' }}>Reviews Not Found</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    </div>
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  review: id => dispatch(getReviews(id)),
  Deletereview: id => dispatch(deleteReviewList(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(SingleProdReview)
